import { __decorate, __metadata } from "tslib";
import { Serialize } from '@ftr/serialization';
import { LocalDate } from '@js-joda/core';
import { TimeRange } from './TimeRange';
/**
 * Represents a LocalDate time range. Contains two LocalDate instances, one that
 * specifies the start of the range and another that specifies the end of the range.
 */
export class LocalDateRange extends TimeRange {
    static parse(textOrStart, end) {
        const [startText, endText] = end ? [textOrStart, end] : textOrStart.split(TimeRange.separator);
        return new LocalDateRange(LocalDate.parse(startText), LocalDate.parse(endText));
    }
    /**
     * Returns the range with the earliest start date from the given array.
     * @throws Error if array is empty
     */
    static getEarliest(ranges) {
        if (!ranges.length) {
            throw new Error('Empty array');
        }
        return [...ranges].sort((a, b) => a.start.compareTo(b.start)).shift();
    }
    /**
     * Returns the range with the latest end date from the given array.
     * @throws Error if array is empty
     */
    static getLatest(ranges) {
        if (!ranges.length) {
            throw new Error('Empty array');
        }
        return [...ranges].sort((a, b) => a.end.compareTo(b.end)).pop();
    }
}
__decorate([
    Serialize(),
    __metadata("design:type", LocalDate)
], LocalDateRange.prototype, "start", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", LocalDate)
], LocalDateRange.prototype, "end", void 0);
